import React, { createRef } from 'react';
import { useSelector } from 'react-redux';

import { Grid } from '~/components';
import { t } from '~/helpers';
import {
  estoquePostosInRequest,
  recordFiltering,
  resetFiltering,
} from '~/store/modules/operacaoestoqueposto/actions';

import { Graph, Stations, Alarms } from './components';

export default function OperacaoEstoquePosto() {
  const estoquePosto = useSelector((state) => state.operacaoestoqueposto);

  const alarms = createRef();
  const stations = createRef();

  return (
    <>
      <Grid
        state={estoquePosto}
        read={estoquePostosInRequest}
        filter={recordFiltering}
        reset={resetFiltering}
        timeOut={30000}
        component={(props) => (
          <Graph
            {...props}
            station={() => stations.current.handleToggleModal(props)}
            alarms={(param) => alarms.current.handleToggleModal(param)}
          />
        )}
        sidebar={[
          {
            type: 'autocomplete',
            name: 'idposto',
            label: t('c.menu.stock.posto'),
            param: {
              url: 'postoscomboios',
              unique: 'idposto',
              label: 'codigonomeposto',
            },
          },
          {
            type: 'select',
            name: 'falhacomunicacaotanquefisico',
            label: t('c.menu.alarme.titulo'),
            options: [
              { label: t('s.geral.opcoes.sim'), value: 1 },
              { label: t('s.geral.opcoes.nao'), value: 0 },
            ],
            ruleType: (value) =>
              value === '0' ? 'MENOR_IGUAL' : 'MAIOR_IGUAL',
          },
        ]}
      />

      <Stations ref={stations} />
      <Alarms ref={alarms} />
    </>
  );
}
